import { isCollector, User } from '@/apis/aniftyBackend/users/interface';
import createMiddleEllipsis from '@/utils/createMiddleEllipsis';

/**
 * Get displayName of user
 * according to their user type and current locale
 *
 * @param user user object
 * @param locale current locale (`en` or `ja`)
 * @returns {string} display name
 */
const getDisplayName = (user: User, locale = 'en'): string => {
  // return omitted public address if neither collector/creator profile is set
  if (!user.collectorProfile && !user.creatorProfile) {
    return createMiddleEllipsis(user.userID);
  }

  // return displayName in collector profile
  // if user is collector
  if (isCollector(user)) {
    if (locale === 'ja' && user.collectorProfile.displayNameJA) {
      return user.collectorProfile.displayNameJA;
    }

    // fallback to English
    return user.collectorProfile.displayName;
  }

  // return localized displayName from creator profile if user is creator
  if (locale === 'ja' && user.creatorProfile.nameJA) {
    return user.creatorProfile.nameJA;
  }

  // fallback to English
  return user.creatorProfile.nameEN;
};

export default getDisplayName;
